export default {
    siteMetadata: {
        title: 'NobleWills',
        description:
            'NobleWills is an online estate planning service in Hong Kong, Singapore, and the United States. Writing your Will using our platform is simple, fast, secure, and affordable.',
        keywords: 'Wills, online Will template, estate planning, guardianship, executors, trustees, probate',
    },
};
